import { render, staticRenderFns } from "./PolicyGroupContent.vue?vue&type=template&id=242f52d0&scoped=true&"
import script from "./PolicyGroupContent.vue?vue&type=script&lang=js&"
export * from "./PolicyGroupContent.vue?vue&type=script&lang=js&"
import style0 from "./PolicyGroupContent.vue?vue&type=style&index=0&id=242f52d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f52d0",
  null
  
)

export default component.exports